import script from "./choiceCoupon.vue?vue&type=script&setup=true&lang=js"
export * from "./choiceCoupon.vue?vue&type=script&setup=true&lang=js"

import "./choiceCoupon.vue?vue&type=style&index=0&id=eee50220&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eee50220"]])

export default __exports__